// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"c13e2b11","205":"c9f313b1","239":"e39fb35b","403":"021ec7f8","455":"44b74a4f","551":"8912905c","672":"477a6254","842":"01821987","977":"459ae33c"}[chunkId] + ".chunk.js";
};